import { styled } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import * as Pages from "../pages";

class AppRoutes {
  static readonly Browse = {
    Home: `/`,
    PrivacyPolicy: `privacy-policy`,
    TermsOfUse: `terms-of-use`,
    Faq: `faq`,
  };
}

const BaseContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh", // Make sure the container takes at least the full height of the viewport
  width: "100%",
  backgroundColor: theme.palette.background.default,
}));

export const Router = (): React.ReactElement => {
    
  return (
    <BaseContainer>
      <Navbar />
      <div style={{ flexGrow: 1 }}>
        <Routes>
          {/* Define your Route components here */}
          <Route path={AppRoutes.Browse.Home} element={<Pages.LandingPage />} />
          <Route
            path={AppRoutes.Browse.PrivacyPolicy}
            element={<Pages.PrivacyPolicyPage />}
          />
          <Route
            path={AppRoutes.Browse.TermsOfUse}
            element={<Pages.TermsOfUsePage />}
          />
          {/* <Route path={AppRoutes.Browse.Faq} element={<Faq />} /> */}
          {/* Redirect for undefined paths */}
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </div>
      <Footer />
    </BaseContainer>
  );
};
